<template>
  <v-app>
    <snackbar />
    <loader-fullscreen />
    <router-view></router-view>
  </v-app>
</template>

<script>
import Snackbar from '@/modules/snackbar/_components/snackbar';
import LoaderFullscreen from '@/modules/loader/_components/loaderFullscreen';

export default {
  name: 'App',
  components: {
    LoaderFullscreen,
    Snackbar,
  },
};
</script>

<style lang="scss">
  @import '@/styles/index.scss';

  .v-card .material-icons {
    display: inline-flex;
  }

  /* Remove in 1.2 */
  /*.v-datatable thead th.column.sortable i {*/
    /*vertical-align: unset;*/
  /*}*/
</style>
